import { useQuery } from '@tanstack/react-query';

import { getValidDeliveryDaysNoSub } from 'api/jalapeno';
import { isDayAfter } from 'utils/dateUtils';

const fetchValidDeliveryDays = async ({ deliveryInterval, funnelType, zip }) => {
    const response = await getValidDeliveryDaysNoSub({
        funnelType,
        deliveryInterval,
        zip,
    });

    const availableDays = response.data.days
        .filter((day) => !day.full)
        .sort((a, b) => (isDayAfter(a.dateOfFirstOrder.date, b.dateOfFirstOrder.date) ? -1 : 1));

    return {
        ...response.data,
        availableDays,
        zip,
    };
};

export const VALID_DELIVERY_DAYS_QUERY_KEY = 'valid-delivery-days-no-sub';

const useValidDeliveryDaysQuery = ({ deliveryInterval = 1, extendedQueryKeys = [], funnelType, queryProps, zip }) => {
    const query = useQuery({
        queryKey: [VALID_DELIVERY_DAYS_QUERY_KEY, ...extendedQueryKeys],
        queryFn: () => fetchValidDeliveryDays({ funnelType, deliveryInterval, zip }),
        ...queryProps,
    });

    return query;
};

export default useValidDeliveryDaysQuery;
